import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import { useGetAllMemberPapers } from "@api/members/papers/getAll";
import { useGetMemberPaper } from "@api/members/papers/get";
import { getApi } from "@api/apiPath";
import { axiosClient, queryClient } from "@api/clients.ts";
import type { IPaperDisapprovePathParam } from "@api/members/papers/disapprove/path";

const { getPath } = getApi("members.papers.paperDisapprove.post");

const postMemberPaperDisapprove: MutationFunction<
  unknown,
  IPaperDisapprovePathParam
> = ({ memberId, paperId, ...data }) => {
  return axiosClient.post(getPath({ memberId, paperId }), data);
};

export const usePostMemberPaperDisapprove = createMutation({
  mutationFn: postMemberPaperDisapprove,
  onSuccess: (_, { memberId, paperId }) => {
    queryClient.invalidateQueries({
      queryKey: useGetAllMemberPapers.getKey(),
    });
    queryClient.invalidateQueries({
      queryKey: useGetMemberPaper.getKey({ memberId, paperId }),
    });
  },
});
